import React, { useState, useEffect } from 'react';

const quotes = [
  { text: "Arise, awake, and stop not until the goal is reached", meaning: "Never give up in pursuit of your dreams and potential" },
  { text: "They alone live, who live for others", meaning: "True life is found in service to humanity" },
  { text: "Where can we go to find God if we cannot see Him in our own hearts and in every living being?", meaning: "The divine is within all of us" },
  { text: "The great religion is to be true to this world", meaning: "Spirituality and practical action must go together" },
  { text: "Help and not fight; Assimilation and not Destruction", meaning: "Unity and cooperation over conflict" },
  { text: "All love is expansion, all selfishness is contraction", meaning: "Selfless service expands consciousness" },
  { text: "Each soul is potentially divine. The goal is to manifest this divinity within", meaning: "Every human has unlimited potential waiting to be awakened" },
];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;1,500&family=DM+Sans:wght@400;500&display=swap');
.vq-wrap {
  text-align:center; padding:1rem 2rem;
  font-family:'DM Sans',sans-serif;
  max-width:780px; margin:0 auto;
}
.vq-icon { font-size:2rem; opacity:.6; display:block; margin-bottom:1.25rem; }
.vq-quote {
  font-family:'Playfair Display',Georgia,serif;
  font-size:clamp(1.2rem,2.8vw,1.7rem);
  font-style:italic; font-weight:500;
  color:#fff; line-height:1.5;
  margin:0 0 1rem;
  transition:opacity .5s ease;
}
.vq-author {
  font-size:.8rem; font-weight:600; letter-spacing:.12em;
  text-transform:uppercase; color:rgba(255,255,255,.5);
  margin-bottom:.6rem;
}
.vq-meaning {
  font-size:.9rem; color:rgba(255,255,255,.55);
  font-style:italic; line-height:1.6; margin-bottom:1.5rem;
}
.vq-dots { display:flex; gap:6px; justify-content:center; flex-wrap:wrap; }
.vq-dot {
  width:6px; height:6px; border-radius:50%;
  background:rgba(255,255,255,.25); cursor:pointer;
  transition:all .25s; border:none; padding:0;
}
.vq-dot.active { background:#f39c12; transform:scale(1.3); width:18px; border-radius:3px; }
`;

export default function VivekanandaQuote() {
  const [cur, setCur] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const t = setInterval(() => {
      setFade(false);
      setTimeout(() => { setCur(p => (p + 1) % quotes.length); setFade(true); }, 300);
    }, 8000);
    return () => clearInterval(t);
  }, []);

  const jump = (i) => {
    setFade(false);
    setTimeout(() => { setCur(i); setFade(true); }, 200);
  };

  return (
    <div className="vq-wrap">
      <style>{CSS}</style>
      <span className="vq-icon">❝</span>
      <p className="vq-quote" style={{ opacity: fade ? 1 : 0 }}>
        {quotes[cur].text}
      </p>
      <p className="vq-author">— Swami Vivekananda</p>
      <p className="vq-meaning" style={{ opacity: fade ? 1 : 0 }}>{quotes[cur].meaning}</p>
      <div className="vq-dots">
        {quotes.map((_, i) => (
          <button key={i} className={`vq-dot${i === cur ? ' active' : ''}`} onClick={() => jump(i)} aria-label={`Quote ${i+1}`}/>
        ))}
      </div>
    </div>
  );
}